import { makeStyles } from 'tss-react/mui';

const ReAttemptStyles = makeStyles()(() => ({
  reAttemptHeading: {
    margin: '1.875rem 0rem',
  },
  reAttemptText: {
    margin: '1.875rem 0rem',
  },
}));

export default ReAttemptStyles;
